import { render, staticRenderFns } from "./EquipmentTopTenPieChart.vue?vue&type=template&id=18e52338&scoped=true&"
import script from "./EquipmentTopTenPieChart.vue?vue&type=script&lang=js&"
export * from "./EquipmentTopTenPieChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e52338",
  null
  
)

export default component.exports